import { Box, Container } from "@mui/material";
import Skeleton from "react-loading-skeleton";

const ProductDetailsSkelton = () => {
  return (
    <Container>
      <div style={{}}>
        <Skeleton style={{ width: "100%", height: "60px" }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: "20px",
            marginTop: "10px",
            padding: "10px",
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", md: "10%" },
              height: { xs: "60px", md: "100vh" },
              order: { xs: 2, md: 1 },
              display: "flex",
              gap: "10px",
              flexDirection: { xs: "row", md: "column" },
            }}
          >
            {Array.from({ length: 5 }, (_, index) => index).map((item) => (
              <Skeleton className="sklt-min-img" />
            ))}
          </Box>
          <Box
            sx={{
              width: { xs: "100%", md: "40%" },
              height: { xs: "40vh", md: "80vh" },
              order: { xs: 1, md: 2 },
            }}
          >
            <Skeleton style={{ width: "100%", height: "100%" }} />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              flexGrow: 1,
              order: { xs: 3, md: 3 },
            }}
          >
            <Skeleton style={{ width: "100%", height: "30px" }} count={2} />
            <hr />
            <Skeleton style={{ width: "100%" }} count={3} />
            <Skeleton className="sklt-first-box" />
            <Skeleton className="sklt-second-box" />
          </Box>
        </Box>
      </div>
    </Container>
  );
};
export default ProductDetailsSkelton;
